var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',_vm._g(_vm._b({class:['form-button', _vm.size ? _vm.size : 'default', _vm.float ? _vm.float : 'right', { disabled: _vm.isLoading }],attrs:{"type":"submit"}},'b-button',_vm.$attrs,false),_vm.$listeners),[_vm._v(_vm._s(_vm.title || 'Salvar'))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-117dbdf9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/FormButton.vue
// module id = 884
// module chunks = 0